var _circle, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrongSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0E5CF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1467_4606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 4,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4375 16.3574H13.562V19.5786H10.4375V16.3574Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1467_4606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.562 17.968C13.562 18.8575 12.8625 19.5787 11.9996 19.5787C11.1368 19.5787 10.4375 18.8575 10.4375 17.968C10.4375 17.0785 11.1368 16.3574 11.9996 16.3574C12.8625 16.3574 13.562 17.0785 13.562 17.968Z",
    fill: "#0E5CF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1467_4606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 4,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1055 4.4209H13.8949V14.9776H10.1055V4.4209Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1467_4606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5067 13.4381C10.5067 14.2883 11.1754 14.9776 12.0001 14.9776C12.8251 14.9776 13.4938 14.2883 13.4938 13.4381L13.895 6.37429C13.895 5.29548 13.0466 4.4209 12.0001 4.4209C10.9539 4.4209 10.1055 5.29548 10.1055 6.37429L10.5067 13.4381Z",
    fill: "#0E5CF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrongSign);
export default __webpack_public_path__ + "static/media/somethingWentWrongSign.e3931cc90c1b3316b8b005c7e6e608ed.svg";
export { ForwardRef as ReactComponent };